// extracted by mini-css-extract-plugin
export default {"button":"FastRewindButton_button__fH8JK"};